import React from "react";
import Profile from "../../components/Profile/Profile";

const ProfilePage: React.FC = () => {
  return (
    <div>
      <Profile />
    </div>
  );
};

export default ProfilePage;
